export const USER_INFO = 'setUserInfo'
export const SETTING_TIMER = 'settingTimer'
export const RESET_TIMER = 'resetTimer'
export const DECREMENT_TIMER = 'decrementTimer'
export const ADM_USER_INFO = 'admUserInfo'
export const HAD_TAB_LOGIN = 'setHadTabLogin'
export default {
  USER_INFO,
  SETTING_TIMER,
  RESET_TIMER,
  DECREMENT_TIMER,
  ADM_USER_INFO,
  HAD_TAB_LOGIN
}
